import { formatMoney } from '@betterment/js-runtime';
import { Separator } from '@betterment/samba-react';
import { ActivityDrawerLayout } from '@betterment/shared-components/src/components/activity/components/drawer/common/ActivityDrawerLayout';
import { DrawerListRow } from '@betterment/shared-components/src/components/activity/components/drawer/common/DrawerListRow';

import { ActivityItemFragment } from '../../../../graphql/fragments/activityItem.generated';
import { NarrowTypename } from '../../../../graphql/utils/narrow-typename';

export const Other: React.FC<{
  item: NarrowTypename<ActivityItemFragment, 'ActivityItemOther'>;
}> = ({ item }) => {
  return (
    <ActivityDrawerLayout title={item.description ? item.description : 'Other'}>
      <DrawerListRow label="Account" value={item.subAccount.envelope.purpose?.name ?? item.subAccount.name} />
      <Separator />
      {item.amount && (
        <>
          <DrawerListRow label="Amount" value={formatMoney(item.amount)} />
          <Separator />
        </>
      )}
    </ActivityDrawerLayout>
  );
};
